<div [formGroup]="parentForm" class="flex flex-col items-start gap-4 mb-12 mt-8">
  <div class="flex justify-start gap-6"> 
    <div class="flex flex-col items-center">
      <label class="cursor-pointer">
        <input
          type="radio"
          formControlName="readFormat"
          value="LR"
          class="peer hidden"/>
        <div
          class="border border-black border-1 peer-checked:border-4 rounded p-4 transition w-max
                 hover:bg-gray-100 active:bg-gray-200
                 peer-checked:ring-4 peer-checked:ring-warning-base">
          <img
            src="assets/icons/one_column.png"
            alt="1 columna"
            class="w-28 h-28 rounded mx-auto"
          />
        </div>
      </label>
      <span class="text-sm mt-2">1 columna</span>
    </div>
    <div class="flex flex-col items-center">
      <label class="cursor-pointer">
        <input
          type="radio"
          formControlName="readFormat"
          value="UD"
          class="peer hidden"/>
        <div
          class="border border-black border-1 peer-checked:border-4 rounded p-4 transition w-max
                 hover:bg-gray-100 active:bg-gray-200
                 peer-checked:ring-4 peer-checked:ring-warning-base">
          <img
            src="assets/icons/more_columns.png"
            alt="Más de 1 columna"
            class="w-28 h-28 rounded mx-auto"/>
        </div>
      </label>
      <span class="text-sm mt-2">Más de 1 columna</span>
    </div>
  </div>
</div>
